export const FORMS_FETCH_CONFIGS = 'forms.fetch-configs';
export const FORMS_SET_CONFIGS = 'forms.set-configs';
export const FORMS_CLEAR_CONFIGS = 'forms.clear-configs';
